module.exports = __webpack_public_path__ + "static/media/image_34.232be0de.png";